export class ModalResponse {
  isConfirm: boolean;
}

export class ErrorImportModel {
  index: string;
  columnName: string;
  value: string;
}

export class OrganizationModel {
  organizationId?: number;
  divisionId?: number;
  subdivisionId?: number;
}

export class ApproveRejectResponse {
  approveDate: Date;
  approveBy: number;
  approveReason: string;
}
